import script from "./AppTextarea.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppTextarea.vue?vue&type=script&setup=true&lang=ts"

import "./AppTextarea.vue?vue&type=style&index=0&id=77efaf00&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77efaf00"]])

export default __exports__